import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import authReducer from './auth/authSlice';
import onboardingReducer from './onboarding/onboardingSlice';
import cookieConsentReducer from './cookie/cookieConsentSlice';
import messageReducer from './message/messageSlice';

import storage from 'redux-persist/lib/storage'; // uses localStorage by default
import { persistReducer, persistStore } from 'redux-persist';

// ✅ Configuration for redux-persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'message', 'onboarding'], // only persist the auth slice
};

// ✅ Combine reducers (in case you have more in future)
const rootReducer = combineReducers({
  cookieConsent: cookieConsentReducer,
  auth: authReducer,
  message: messageReducer,
  onboarding: onboardingReducer
});

// ✅ Enhance rootReducer with persist capabilities
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // needed to ignore non-serializable Redux Persist actions
  }),
});

// ✅ Create persistor
export const persistor = persistStore(store);

// ✅ Export store and persistor
export default store;
